import { LCD } from "../../config";
import type { GridSize } from "../../core/types";
import type { DrawContext } from "../text";

/** Grid hücresine içeriği `inset` kadar çekilmiş koyu blok çizer. */
export function drawBlockAt(rc: DrawContext, x: number, y: number, inset = 1): void {
  const { cell, headerH, offX, offY } = rc.layout;
  const px = offX + x * cell;
  const py = offY + headerH + y * cell;
  rc.ctx.fillStyle = LCD.dark;
  rc.ctx.fillRect(px + inset, py + inset, cell - inset * 2, cell - inset * 2);
}

/**
 * Yem bloğu — yılandan ayrışması için dolgu açık LCD tonunda, çerçeve koyu.
 */
export function drawFoodAt(rc: DrawContext, x: number, y: number): void {
  const { cell, headerH, offX, offY } = rc.layout;
  const px = offX + x * cell;
  const py = offY + headerH + y * cell;

  const border = Math.max(2, Math.floor(cell * 0.12));
  const { ctx } = rc;
  ctx.fillStyle = LCD.dark;
  ctx.fillRect(px, py, cell, cell);
  ctx.fillStyle = LCD.light;
  ctx.fillRect(px + border, py + border, cell - border * 2, cell - border * 2);
}

/**
 * Oyun alanı çerçevesi.
 * - Duvar geçişi kapalı: sürekli, kalın duvar.
 * - Duvar geçişi açık: kesikli, soluk çizgi (kenarlardan geçilebilir).
 */
export function drawWallFrame(rc: DrawContext, grid: GridSize, wallPass: boolean): void {
  const { cell, headerH, offX, offY } = rc.layout;
  const px = offX;
  const py = offY + headerH;
  const fieldW = grid.cols * cell;
  const fieldH = grid.rows * cell;
  const { ctx } = rc;

  if (!wallPass) {
    ctx.fillStyle = LCD.dark;
    ctx.fillRect(px - 2, py - 2, fieldW + 4, 2);
    ctx.fillRect(px - 2, py + fieldH, fieldW + 4, 2);
    ctx.fillRect(px - 2, py, 2, fieldH);
    ctx.fillRect(px + fieldW, py, 2, fieldH);
    return;
  }

  ctx.setLineDash([4, 6]);
  ctx.strokeStyle = LCD.dark;
  ctx.globalAlpha = 0.4;
  ctx.lineWidth = 2;
  ctx.strokeRect(px - 1, py - 1, fieldW + 2, fieldH + 2);
  ctx.setLineDash([]);
  ctx.globalAlpha = 1;
}
